import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup } from 'react-bootstrap'
// import { momentHelper } from '../helpers'
// import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import StockStore from 'stores/StockStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
// import FontAwesome from 'react-fontawesome'
// import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'

import '../report.css'
// import { connect } from 'react-redux';

class ReportBalanceMaterial extends Component {
  constructor(props) {
    super(props)
    
    this.state = {
      loading:false,
      activePage:1,
      groupId:'all',
      groupList:[{label:'เลือกทั้งหมด',value:'all'}],
      data:[]
    }
    this.refTableId = 'ReportBalanceMaterial-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.groupId)
      this.loadCategory()
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadData(groupId='') {  
    this.setState({loading:false})
    ReportStore.loadUsageVolumeBalance(groupId,(result)=>{
        this.setState({loading:false,data:result.data})
    })   
  }

  loadCategory() {
      let groupList = [{label:'เลือกทั้งหมด',value:'all'}]
      StockStore.loadCategory('officemate',(result)=>{
        result.data.forEach((item,index)=>{
            groupList.push({label:item.name,value:item.cat_id})
        })
        this.setState({groupList:groupList})
      })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{item.balance_quantity}</td>
              <td className='text-right'>{this.getNumberFormat(item.total_cost)}</td>
            </tr>
        ) 
      )  
    }
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered-solid' style={{minWidth:'1400px'}}>
          <thead>
            <tr>
              <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center' style={{width:'150px'}}>ชื่อสี</th>
              <th className='text-center' style={{width:'200px'}}>คำอธิบาย</th>
              <th className='text-center' style={{width:'100px'}}>ปริมาณคงเหลือ (กรัม)</th>
              <th className='text-center' style={{width:'100px'}}>มูลค่ายอดเงิน</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={3} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-center'>{this.getSummary('balance_quantity')}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('total_cost'))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onGroupChange(val) {
    this.setState({
      groupId: val.value
    })
    this.loadData(val.value)
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานของเหลวและสีคงเหลือ.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    let url = ''
    let param = 'PrintReportBalanceMaterial&groupId='+this.state.groupId  
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  renderToolbar() {
    return(
      <Form inline>
        <div style={{ width: '150px', display: 'inline-block'}}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.groupId}
            options={this.state.groupList}
            onChange={this.onGroupChange.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportBalanceMaterial.defaultProps = {
  show : false
}

export default ReportBalanceMaterial;


// WEBPACK FOOTER //
// ./src/view/report/material/ReportBalanceMaterial.js